import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Carousel.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CarouselLoading = function CarouselLoading(_ref) {
  var item = _ref.item;
  var items = Array(4).fill();
  return /*#__PURE__*/_jsx("div", {
    className: css.carousel,
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsxs("ul", {
      className: css.items,
      children: [/*#__PURE__*/_jsx("li", {
        "aria-hidden": "true",
        className: css.ghost,
        children: "\xA0"
      }), items.map(function (_, idx) {
        return /*#__PURE__*/_jsx("li", {
          className: cc([css.itemWrap, css.loading]),
          children: /*#__PURE__*/_jsx("div", {
            className: css.imageWrapper,
            children: /*#__PURE__*/_jsx("div", {
              className: css.image,
              children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, item.image), {}, {
                wrap: false
              }))
            })
          })
        }, "carousel-item-".concat(idx));
      }), /*#__PURE__*/_jsx("li", {
        "aria-hidden": "true",
        className: css.ghost,
        children: "\xA0"
      })]
    })
  });
};

CarouselLoading.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    image: PropTypes.shape({
      id: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired
    })
  }).isRequired
};
export default CarouselLoading;